import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentsViewSettings } from '../view-settings/viewSettings';
import { FormControl } from '@angular/forms';
import { CurrentUserService } from '../../../../core/services/current-user.service';
import { map } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewSettingsModalComponent } from './view-settings-modal/view-settings-modal.component';

@Component({
  selector: 'app-document-search-results-header',
  templateUrl: './document-search-results-header.component.html',
  styles: []
})
export class DocumentSearchResultsHeaderComponent implements OnInit {
  @Input() viewSettings!: DocumentsViewSettings;
  @Output() sortingChanged = new EventEmitter<void>();
  @Output() exportDocumentsClicked = new EventEmitter<void>();
  @Output() importDocumentsClicked = new EventEmitter<void>();

  userPermissions$ = this.currentUserService.get().pipe(map((user) => user.accessRights));
  sorting = new FormControl<string>(null);

  constructor(private currentUserService: CurrentUserService, private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.sorting.setValue(this.viewSettings.getSorting());
  }

  updateSorting(): void {
    this.viewSettings.updateSorting(this.sorting.value);
  }

  updateViewSettings(): void {
    const modal = this.modalService.open(ViewSettingsModalComponent, { backdrop: 'static' });
    modal.componentInstance.viewSettings = this.viewSettings;
    modal.result.then(
      () => {
      },
      () => {
      }
    );
  }
}
